import { Component, Input, OnInit } from '@angular/core'
import { fuseAnimations } from '../../../../core/animations'
import { AdministrationService } from '../../../services/administration.service'
import { AdministrationModel } from '../../../models/administration.model'

@Component({
  selector: 'app-administration-sidenav',
  templateUrl: './administration-sidenav.component.html',
  styleUrls: ['./administration-sidenav.component.scss'],
  animations: fuseAnimations,
})
export class AdministrationSidenavComponent implements OnInit {
  @Input() administration: AdministrationModel
  activeState: string

  constructor(private administrationService: AdministrationService) {}

  ngOnInit() {}
  /**
   *
   * @returns {boolean}
   */
  hasNoFilters(): boolean {
    if (this.activeState == undefined) {
      return true
    }

    return false
  }

  /**
   *
   * @param event
   * @param role
   */
  unsetFilter(event) {
    event.stopPropagation()
    this.activeState = undefined
    this.administrationService.clearFilter()
  }

  filterStopped(event, field) {
    this.activeState = field
    this.administrationService.isStopped(true)
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/administrations/administration-sidenav/administration-sidenav.component.ts